import Button from '../../../components/Button'
import ArrowDownIcon from '../../../icons/ArrowDownIcon'
import { OUT_OF_THE_APP, VIEWPORT_LG } from '../../../utils/constants'
import bootstrap from 'bootstrap/dist/js/bootstrap.min.js'
import { TYPE_OF_TAB_BAR_BUTTONS } from './TabBar'
import Badge from '../../../components/Badge/Badge'

import CustomModal from '../../../components/Modals/CustomModal'
import Swal from 'sweetalert2'
import FilterModalIcon from '../../../icons/Modals/FilterModalIcon'
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from '../../../Routes/routes'
import { useNavigate } from 'react-router-dom'
import FilterModalIconTwo from '../../../icons/Modals/FilterModalIconTwo'
import useResize from '../../../hooks/useResize'
import FiltersIcon from '../../../icons/FiltersIcon'
import ArrowRigthIcon from '../../../icons/ArrowRigthIcon'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchTalentsFiltersStore } from '../../../store'

const Filters = ({
  setSelectedButton,
  selectedCategories,
  selectedSkills,
  selectedLanguages,
  selectedExperience,
  selectedSectors,
  selectedCountries,
  selectedPromote,
  setGlobalPage,
  setData,
  setFilterByWords,
  setFilterUsernameOrEmail,
  isJuniorView = false,
}) => {
  const { t } = useTranslation()
  const { setIsOpenModal } = useSearchTalentsFiltersStore()
  const navigate = useNavigate()
  const isTalentsView =
    window.location.pathname === PRIVATE_ROUTES.talents || isJuniorView
  const viewportSize = useResize()
  const [filterByWordsValue, setFilterByWordsValue] = useState('')
  const [filterUsernameOrEmailValue, setFilterUsernameOrEmailValue] =
    useState('')

  const {
    all,
    categories,
    skills,
    english,
    experience,
    sector,
    country,
    promote,
  } = TYPE_OF_TAB_BAR_BUTTONS

  const handleOpenFiltersModal = ({ typeFilter = all }) => {
    if (OUT_OF_THE_APP) {
      if (!isTalentsView) {
        CustomModal({
          Image: () => <FilterModalIcon />,
          title: t('find_your_talent'),
          description: t(
            'sign_up_to_use_the_filter_tool_to_find_your_ideal_candidate_faster_or_browse_all_available_talent_without_signing_up'
          ),
          textPrimaryButton: t('see_all_talents'),
          textSecondaryButton: t('sign_up_two'),
          classNameTextPrimaryButton: `${
            viewportSize[0] <= VIEWPORT_LG ? 'font-extra-small' : 'font-small'
          } `,
          classNameSecondaryButton: `${
            viewportSize[0] <= VIEWPORT_LG ? 'font-extra-small' : 'font-small'
          } `,
          handlePrimaryButton: () => {
            navigate(PRIVATE_ROUTES.talents)
            Swal.close()
          },
          handleSecondaryButton: () => {
            navigate(PUBLIC_ROUTES.register_by_company)
            Swal.close()
          },
        })
        return
      }
      if (isTalentsView) {
        CustomModal({
          Image: () => <FilterModalIconTwo />,
          title: t('become_a_pro_for_free'),
          description: t(
            'register_to_access_filter_and_save_your_favorite_candidates'
          ),
          textPrimaryButton: t('go_pro_for_free_now'),
          classNameTextPrimaryButton: `${
            viewportSize[0] <= VIEWPORT_LG ? 'font-extra-small' : 'font-small'
          } `,
          handlePrimaryButton: () => {
            navigate(PUBLIC_ROUTES.register_by_company)
            Swal.close()
          },
          showSecondaryButton: false,
          titleClassName: 'mt-4',
        })
        return
      }
      return
    }

    setIsOpenModal(true)
    setSelectedButton(typeFilter)
    const modal = bootstrap.Modal.getOrCreateInstance('#filter-modal')
    modal.show()
  }

  const allCategories = selectedCategories?.length
  const allSkills = selectedSkills?.length
  const allLanguages = selectedLanguages?.length
  const allExperience = selectedExperience?.length
  const allSectors = selectedSectors?.length
  const allCountries = selectedCountries?.length

  return (
    <div className="border rounded p-3 shadow-sm mb-3">
      {' '}
      {viewportSize[0] <= VIEWPORT_LG ? (
        <div
          className="d-flex justify-content-between align-items-center"
          onClick={() => handleOpenFiltersModal({ typeFilter: categories })}
        >
          <div>
            <FiltersIcon />
            <span className="text-decoration-underline text-on-bg-primary ms-2">
              {t('filters')}
            </span>
          </div>
          <ArrowRigthIcon />
        </div>
      ) : (
        <div className="d-flex flex-column gap-3">
          <div className="d-flex align-items-center gap-3">
            <Button
              className="border border-on-bg-Tertiary text-on-bg-secondary text-start w-100 d-flex align-items-center justify-content-between"
              onClick={() => handleOpenFiltersModal({ typeFilter: categories })}
              type="button"
              role="button"
            >
              <span>
                {allCategories > 0 ? (
                  <div className="d-flex align-items-center gap-1">
                    <span>{t('category')}</span>
                    <Badge className="bg-bg-CTA-complementary-pressed  text-on-bg-primary rounded-pill me-2">
                      {`+${allCategories}`}
                    </Badge>
                  </div>
                ) : (
                  <span>{t('category')}</span>
                )}
              </span>
              <ArrowDownIcon />
            </Button>
            <Button
              className="border border-on-bg-Tertiary text-on-bg-secondary text-start w-100 d-flex align-items-center justify-content-between"
              onClick={() => handleOpenFiltersModal({ typeFilter: skills })}
              type="button"
              role="button"
            >
              {allSkills > 0 ? (
                <div className="d-flex align-items-center gap-1">
                  <span>{t('skills')}</span>
                  <Badge className="bg-bg-CTA-complementary-pressed  text-on-bg-primary rounded-pill me-2">
                    {`+${allSkills}`}
                  </Badge>
                </div>
              ) : (
                <span>{t('skills')}</span>
              )}
              <ArrowDownIcon />
            </Button>
            <Button
              className="border border-on-bg-Tertiary text-on-bg-secondary text-start w-100 d-flex align-items-center justify-content-between"
              onClick={() => handleOpenFiltersModal({ typeFilter: english })}
              type="button"
              role="button"
            >
              {allLanguages > 0 ? (
                <div className="d-flex align-items-center gap-1">
                  <span>Idiomas</span>
                  <Badge className="bg-bg-CTA-complementary-pressed  text-on-bg-primary rounded-pill me-2">
                    {`+${allLanguages}`}
                  </Badge>
                </div>
              ) : (
                <span>Idiomas</span>
              )}
              <ArrowDownIcon />
            </Button>
            <Button
              className="border border-on-bg-Tertiary text-on-bg-secondary text-start w-100 d-flex align-items-center justify-content-between"
              onClick={() => handleOpenFiltersModal({ typeFilter: experience })}
              type="button"
              role="button"
            >
              {allExperience > 0 ? (
                <div className="d-flex align-items-center gap-1">
                  <span>{t('experience')}</span>
                  <Badge className="bg-bg-CTA-complementary-pressed  text-on-bg-primary rounded-pill me-2">
                    {`+${allExperience}`}
                  </Badge>
                </div>
              ) : (
                <span>{t('experience')}</span>
              )}
              <ArrowDownIcon />
            </Button>
            <Button
              className="border border-on-bg-Tertiary text-on-bg-secondary text-start w-100 d-flex align-items-center justify-content-between"
              onClick={() => handleOpenFiltersModal({ typeFilter: sector })}
              type="button"
              role="button"
            >
              {allSectors > 0 ? (
                <div className="d-flex align-items-center gap-1">
                  <span>{t('sector')}</span>
                  <Badge className="bg-bg-CTA-complementary-pressed  text-on-bg-primary rounded-pill me-2">
                    {`+${allSectors}`}
                  </Badge>
                </div>
              ) : (
                <span>{t('sector')}</span>
              )}
              <ArrowDownIcon />
            </Button>
            <Button
              className="border border-on-bg-Tertiary text-on-bg-secondary text-start w-100 d-flex align-items-center justify-content-between"
              onClick={() => handleOpenFiltersModal({ typeFilter: country })}
              type="button"
              role="button"
            >
              {allCountries > 0 ? (
                <div className="d-flex align-items-center gap-1">
                  <span>{t('country')}</span>
                  <Badge className="bg-bg-CTA-complementary-pressed  text-on-bg-primary rounded-pill me-2">
                    {`+${allCountries}`}
                  </Badge>
                </div>
              ) : (
                <span>{t('country')}</span>
              )}
              <ArrowDownIcon />
            </Button>
            <Button
              className="border border-on-bg-Tertiary text-on-bg-secondary text-start w-100 d-flex align-items-center justify-content-between"
              onClick={() => handleOpenFiltersModal({ typeFilter: promote })}
              type="button"
              role="button"
            >
              <span>Promocionar</span>
              <ArrowDownIcon />
            </Button>
          </div>

          <div
            className={`d-flex gap-1 w-100 ${
              isJuniorView
                ? 'align-items-end justify-content-end'
                : 'align-items-start'
            }`}
          >
            <input
              className="form-control w-100"
              placeholder="Buscar por profesión"
              value={filterByWordsValue}
              onChange={(evt) => {
                const value = evt?.target?.value
                setFilterByWordsValue(value)
                setFilterByWords(value)
              }}
            />
            <input
              className="form-control w-100"
              placeholder="Buscar por email o usuario"
              value={filterUsernameOrEmailValue}
              onChange={(evt) => {
                const value = evt?.target?.value
                setFilterUsernameOrEmailValue(value)
                setFilterUsernameOrEmail(value)
              }}
            />

            <Button
              type="submit"
              onClick={() => {
                setGlobalPage(0)
                setData([])
              }}
            >
              <span>{t('search')}</span>
            </Button>
          </div>
          {(allCategories > 0 ||
            allSkills > 0 ||
            allLanguages > 0 ||
            allExperience > 0 ||
            allSectors > 0 ||
            allCountries > 0 ||
            selectedPromote) && (
            <div className="d-flex flex-wrap gap-2 mt-2">
              {selectedCategories.map((cat) => (
                <Badge
                  key={`cat-${cat.id}`}
                  className="d-flex align-items-center gap-1 bg-bg-CTA-complementary-pressed text-on-bg-primary rounded-pill"
                >
                  {cat.name}
                </Badge>
              ))}
              {selectedSkills.map((skill) => (
                <Badge
                  key={`skill-${skill.id}`}
                  className="d-flex align-items-center gap-1 bg-bg-CTA-complementary-pressed text-on-bg-primary rounded-pill"
                >
                  {skill.skill?.name || skill.name}
                </Badge>
              ))}
              {selectedLanguages.map((lang) => (
                <Badge
                  key={`lang-${lang.id}`}
                  className="d-none d-flex align-items-center gap-1 bg-bg-CTA-complementary-pressed text-on-bg-primary rounded-pill"
                >
                  {lang.languaje?.name} {lang.lang_level?.name}
                </Badge>
              ))}
              {selectedExperience.map((exp) => (
                <Badge
                  key={`exp-${exp.id}`}
                  className="d-flex align-items-center gap-1 bg-bg-CTA-complementary-pressed text-on-bg-primary rounded-pill"
                >
                  {exp.name}
                </Badge>
              ))}
              {selectedSectors.map((sec) => (
                <Badge
                  key={`sec-${sec.id}`}
                  className="d-flex align-items-center gap-1 bg-bg-CTA-complementary-pressed text-on-bg-primary rounded-pill"
                >
                  {sec.name}
                </Badge>
              ))}
              {selectedCountries.map((cou) => (
                <Badge
                  key={`cou-${cou.id}`}
                  className="d-flex align-items-center gap-1 bg-bg-CTA-complementary-pressed text-on-bg-primary rounded-pill"
                >
                  {cou.name}
                </Badge>
              ))}
              {selectedPromote && (
                <Badge className="d-flex align-items-center gap-1 bg-bg-CTA-complementary-pressed text-on-bg-primary rounded-pill">
                 Promocionar: {selectedPromote}
                </Badge>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default Filters
